import React from "react";
import { Button, DropdownButton, Dropdown, Form, Tabs, Tab, Modal, ToggleButton } from 'react-bootstrap';
import { Nav, ListGroup } from 'react-bootstrap';
import { context } from '../../AppContext';
import LineGraph from "../../LineGraph";

export default class StatusGraph extends React.Component {

    state = {  };

    render() {
        let tempData = this.props.detailScreen.getHistoryData("Temperature");
        let phData = this.props.detailScreen.getHistoryData("PH");
        let orpData = this.props.detailScreen.getHistoryData("ORP");
        let voltData = this.props.detailScreen.getHistoryData("Voltage");

        return (
            <div className="StatusGraph" style={{ width: '100%', padding: 10 }}>
                <div className="row">
                    <div className="col-md-2 pull-left">
                        <Button 
                            disabled={ this.props.detailScreen.state.historyLoading } 
                            onClick={ () => this.props.detailScreen.updateHistory() }
                        >Refresh</Button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        Temperature<br/>
                        <LineGraph width="500" height="300" 
                            data={ tempData.data }
                            series={ tempData.series }
                            key="Temperature"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        PH<br/>
                        <LineGraph width="500" height="300" 
                            data={ phData.data }
                            series={ phData.series }
                            key="PH"
                        />
                    </div>
                    <div className="col-md-6">
                        ORP<br/>
                        <LineGraph width="500" height="300" 
                            data={ orpData.data }
                            series={ orpData.series }
                            key="ORP"
                        />
                    </div>
                    <div className="col-md-6" style={{ display: 'none' }}>
                        Temp Voltage<br/>
                        <LineGraph width="500" height="300" 
                            data={ voltData.data }
                            series={ voltData.series }
                            key="TempVolt"
                        />
                    </div>
                </div>
            </div>
        );
    }
}